import React, { memo } from "react";
import { StyleSheet, Text, View, Pressable, Image, Platform } from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import { BlurView } from "expo-blur";
import { useNavigation } from "@react-navigation/native";
import Animated, { FadeInDown } from "react-native-reanimated";

import dimensions from "../../../../globalStyles/dimensions";
import CustomComponent from "../../../../components/CustomComponent";
import GlobalStyles from "../../../../globalStyles/globalStyles";
import ExperienceIcons from "../../../../assets/Icons/ExperienceIcons";
import { Colors } from "../../../../globalStyles/ColorConfig";

const ImageContainer = (props: any) => {
  const navigation = useNavigation();
  const { data } = props;

  if (
    !data ||
    !data?.media ||
    !data?.media?.images ||
    data?.media?.images?.length === 0
  ) {
    // Handle the case where data is undefined or does not have the expected structure
    return null; // or render a placeholder, error message, etc.
  }

  const { media, title, _id } = data;
  const truncatedTitle =
    title?.length > 19 ? `${title?.slice(0, 19)}...` : title;

  return (
    <Pressable onPress={() => navigation.navigate("experience", { _id })}>
      <Animated.View entering={FadeInDown.delay(350)} style={styles.container}>
        <Image
          // source={{
          //   uri:
          //     media?.images[0]?.url ||
          //     "https://images.unsplash.com/photo-1593351415075-3bac9f45c877?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
          // }}
          source={{
            uri: "https://i.pinimg.com/564x/9f/a7/0e/9fa70ee6ef2708c6f16f529989d3315a.jpg",
          }}
          style={styles.coverImage}
        />
        <LinearGradient
          colors={["transparent", "rgba(0,0,0,0.9)"]}
          style={styles.gradient}
        />
        {/* <View
          style={{
            position: "absolute",
            bottom: 10,
            zIndex: 1,
            paddingHorizontal: (Platform.OS === 'ios' || Platform.OS === 'android') ? dimensions.paddingHorizontal : 10,
            // paddingBottom: dimensions.paddingVertical * 2.5,
            paddingBottom: 46,
          }}
        >
          <BlurView style={styles.blurView}
            intensity={40}

          >
            <CustomComponent.TextView
              title="Recommended"
              textStyle={[GlobalStyles.title2, styles.imageTextRecomended,{
                fontSize: 12,
                color:"rgba(255,255,255,0.4)",
                letterSpacing: -0.3,
                paddingHorizontal: 15,
              }]}
            />
          </BlurView>
        </View> */}
        <View style={styles.textView}>
          <CustomComponent.TextView
            title={truncatedTitle}
            textStyle={[GlobalStyles.heading3, styles.imageText,{
              fontFamily: "EBGaramondSemiBold",
              fontSize: 26,
              lineHeight: 37,
              letterSpacing: -0.3,
            
            }]}
          />
          <View
            style={{
              position: "absolute",
              right: (Platform.OS === 'ios' || Platform.OS === 'android') ? dimensions.windowWidth * 0.05 : 10,
              bottom: dimensions.windowHeight * 0.03,
            }}
          >
            <ExperienceIcons.Arrow />
          </View>
        </View>
      </Animated.View>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  container: {
    width: "100%", // Adjust as needed
    marginTop: dimensions.marginVertical * 2,
    overflow: "hidden",
    borderRadius: 20,
    aspectRatio: (Platform.OS === 'ios' || Platform.OS === 'android') ?  13 / 14 : 10/8,
  },
  coverImage: {
    width: "100%",
    height: "100%",
    aspectRatio: 13 / 14,
  },
  gradient: {
    ...StyleSheet.absoluteFillObject,
    position: "absolute",
    zIndex: 1,
    borderRadius: 20,
  },
  textView: {
    position: "absolute",
    width: "100%",
    bottom: 0,
    zIndex: 1,
    paddingHorizontal: (Platform.OS === 'ios' || Platform.OS === 'android') ?dimensions.paddingHorizontal : 20,
    paddingVertical: dimensions.paddingVertical,
  },
  blurView: {
    borderRadius: 20,
    backgroundColor: "rgba(0,0,0,0.1)",
    overflow: "hidden",
  },
  imageText: {
    color: "white",
  },
  imageTextRecomended: {
    fontSize: 16,
    color: Colors.white000,
    paddingHorizontal: dimensions.paddingHorizontal / 2,
    paddingVertical: 5,
  },
});

export default memo(ImageContainer);